import React from "react";
import styles from "./confirmationModal.module.css";

const ConfirmationModal = ({
  content,
  approveBtnText,
  cancelBtnText,
  show,
  onClose,
  onConfirm,
  backdropClick,
}) => {
  /* A generic confirmation modal, with confirm / cancel options. It is used by multiple components in the app. */

  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={backdropClick}>
      {" "}
      {/* Use the backdropClick function */}
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2>Confirmation</h2>
        <p>{content.message}</p>
        {content.type === "palRequest" && (
          <figure className={styles.senderFigure}>
            <img
              src={content.sender_img_link}
              alt={content.sender_first_name + " " + content.sender_last_name}
            />
            <figcaption>
              {content.sender_first_name + " " + content.sender_last_name}
            </figcaption>
          </figure>
        )}
        <div className={styles.modalButtons}>
          <button className={styles.confirmationBtn} onClick={onConfirm}>
            {approveBtnText}
          </button>
          <button onClick={onClose}>{cancelBtnText}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
